export default function (obj, filterFn) {
  var retProps = {};

  if (obj) {
    Object.keys(obj).filter(function (key) {
      return filterFn(key, obj[key]);
    }).forEach(function (key) {
      retProps[key] = obj[key];
    });
  }

  return retProps;
}